import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { MagicCard, MagicCardFace } from "@apiserver-rest/ponder-data-client-base";
import { MagicCardFaceTextComponent } from "./magic-card-face-text.component";

@Component ({
    selector: "magic-card-text",
    imports: [MagicCardFaceTextComponent],
    templateUrl: "./magic-card-text.component.html"
})
export class MagicCardTextComponent {
    @Input({ required: true }) public magicCard!: MagicCard;
    @Input() public isTranslation: boolean = false;

    @ViewChild("oracletextbox") oracleTextRef?: ElementRef<HTMLElement>;
    @ViewChild("oracletextboxtranslation") oracleTextTranslationRef?: ElementRef<HTMLElement>;

    public frontFace!: MagicCardFace;
    public backFaces?: MagicCardFace[];

    constructor() {

    }
    
    public ngOnInit(): void {
        if (this.magicCard.faces!.length == 1) {
            this.frontFace = this.magicCard.faces![0];
        } else {
            this.backFaces = [];

            this.magicCard.faces!.forEach(f => {
                if (f.isFront) {
                    this.frontFace = f;
                } else {
                    this.backFaces!.push(f);
                }
            })
        }
    }
}